import { motion } from 'framer-motion';
import { useT } from '@/lib/i18n';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  title?: string;
  subtitle?: string;
  faqs: FaqItem[];
}

const FADE_UP = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export function FaqSection({
  title,
  subtitle,
  faqs,
}: FaqSectionProps) {
  const t = useT();
  const resolvedTitle = title ?? t('Häufig gestellte Fragen', 'Frequently asked questions');
  return (
    <section className="py-20 relative">
      <div className="absolute inset-0 steel-texture" />
      <div className="container mx-auto px-4 sm:px-6 relative">
        <motion.div className="max-w-3xl mx-auto" {...FADE_UP}>
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-2">
            {resolvedTitle}
          </h2>
          {subtitle && (
            <p className="text-muted-foreground text-center mb-10">{subtitle}</p>
          )}
          {!subtitle && <div className="mb-10" />}

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="card-industrial px-6 border-none"
              >
                <AccordionTrigger className="text-left hover:no-underline text-base font-medium py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5 faq-answer">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
